<div class="xray-items">
  <section class="xray-item-section p-4">
    <!-- Moved p-2 here; removed outer row -->
    <div *ngFor="let group of xraysMediaGroups.displayMediaGroups | categroizedXraysPipe; let i = index; trackBy: trackByIndex">
      <div class="row" [ngClass]="{ 'border-top': i !== 0 }">
        <!-- Each pair in its own row for alignment/equal height -->
        <div class="col-6 border-right">
          <ng-container *ngIf="group.leftMediaGroup as mediaGroup">
            <div class="row xray-item-with-top-line" [hidden]="!mediaGroup.name">
              <div class="col text-left">
                <span class="position-left">LEFT</span>
              </div>
              <div class="col-auto text-center">
                <span class="position-center"> {{ mediaGroup.name }} </span>
                <span class="position-center custom-badge ms-1 bg-danger" *ngIf="mediaGroup.uploadXrayMediaCount != mediaGroup.requiredMediaCount"> {{mediaGroup.uploadXrayMediaCount}} / {{mediaGroup.requiredMediaCount}} </span>
                <span class="position-center custom-badge ms-1 bg-success" *ngIf="mediaGroup.uploadXrayMediaCount == mediaGroup.requiredMediaCount"> {{mediaGroup.uploadXrayMediaCount}} / {{mediaGroup.requiredMediaCount}} </span>
              </div>
              <div class="col text-end">
                <span class="position-right">RIGHT</span>
              </div>
            </div>
            <ng-container *ngFor="let category of mediaGroup.groupedResult; let last = last; trackBy: trackByIndex">
              <div class="row justify-content-center pb-2 pt-2" [ngClass]="{ 'border-bottom': !last }">
                <div class="col-8 card-height  m-2 p-3" [ngClass]="category.isOptional ? 'custom-bg-white box-shadow-radius' : 'custom-bg-green box-shadow-radius'">
                  <div class="row justify-content-lg-center">
                    <div class="col-12 d-flex justify-content-center">
                      <div class="media-category"
                           [ngClass]="category.isPrimaryColor ? 'media-category-primary' : 'media-category-danger'">
                        {{ category.shortName }} {{category.sortOrder}}
                      </div>
                    </div>
                    <div class="col-6 pt-2" [ngClass]="category.isLeftOptional ? '' : 'custom-bg-green'">
                      <ng-container *ngFor="let file of category.leftStudyFiles; trackBy: trackByStudyFile">
                        <app-xray-item [studyFile]="file"
                                       [mediaCategoryId]="file.mediaCategoryId"
                                       [mediaGroups]="mediaGroupsAll$ | async"
                                       [viewMode]="viewMode"
                                       [mediaCategories]="mediaCategories$ | async"
                                       [viewonly]="viewOnly"
                                       [isEditable]="isEditable"
                                       [isShowUpload]="false"
                                       (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                       (viewImage)="viewImage($event)"></app-xray-item>
                      </ng-container>
                    </div>
                    <div class="col-6 pt-2" [ngClass]="category.isRightOptional ? '' : 'custom-bg-green'">
                      <ng-container *ngFor="let file of category.rightStudyFiles; trackBy: trackByStudyFile">
                        <app-xray-item [studyFile]="file"
                                       [mediaCategoryId]="file.mediaCategoryId"
                                       [mediaGroups]="mediaGroupsAll$ | async"
                                       [viewMode]="viewMode"
                                       [mediaCategories]="mediaCategories$ | async"
                                       [viewonly]="viewOnly"
                                       [isEditable]="isEditable"
                                       [isShowUpload]="false"
                                       (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                       (viewImage)="viewImage($event)"></app-xray-item>
                      </ng-container>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>

          </ng-container>
        </div>
        <div class="col-6">
          <ng-container *ngIf="group.rightMediaGroup as mediaGroup">
            <div class="row xray-item-with-top-line" [hidden]="!mediaGroup.name">
              <div class="col text-left">
                <span class="position-left">LEFT</span>
              </div>
              <div class="col-auto text-center">
                <span class="position-center"> {{ mediaGroup.name }} </span>
                <span class="position-center custom-badge ms-1 bg-danger" *ngIf="mediaGroup.uploadXrayMediaCount != mediaGroup.requiredMediaCount"> {{mediaGroup.uploadXrayMediaCount}} / {{mediaGroup.requiredMediaCount}} </span>
                <span class="position-center custom-badge ms-1 bg-success" *ngIf="mediaGroup.uploadXrayMediaCount == mediaGroup.requiredMediaCount"> {{mediaGroup.uploadXrayMediaCount}} / {{mediaGroup.requiredMediaCount}} </span>
              </div>
              <div class="col text-end">
                <span class="position-right">RIGHT</span>
              </div>
            </div>
            <ng-container *ngFor="let category of mediaGroup.groupedResult; let last = last; trackBy: trackByIndex">
              <div class="row justify-content-center pb-2 pt-2" [ngClass]="{ 'border-bottom': !last }">
                <div class="col-8 card-height m-2 p-3" [ngClass]="category.isOptional ? 'custom-bg-white box-shadow-radius' : 'custom-bg-green box-shadow-radius'">
                  <div class="row justify-content-lg-center">
                    <div class="col-12 d-flex justify-content-center">
                      <div class="media-category"
                           [ngClass]="category.isPrimaryColor ? 'media-category-primary' : 'media-category-danger'">
                        {{ category.shortName }}
                      </div>
                    </div>
                    <div class="col-6 pt-2" [ngClass]="category.isLeftOptional ? '' : 'custom-bg-green'">
                      <ng-container *ngFor="let file of category.leftStudyFiles; trackBy: trackByStudyFile">
                        <app-xray-item [studyFile]="file"
                                       [mediaCategoryId]="file.mediaCategoryId"
                                       [mediaGroups]="mediaGroupsAll$ | async"
                                       [viewMode]="viewMode"
                                       [mediaCategories]="mediaCategories$ | async"
                                       [viewonly]="viewOnly"
                                       [isEditable]="isEditable"
                                       [isShowUpload]="false"
                                       (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                       (viewImage)="viewImage($event)"></app-xray-item>
                      </ng-container>
                    </div>
                    <div class="col-6 pt-2" [ngClass]="category.isRightOptional ? '' : 'custom-bg-green'">
                      <ng-container *ngFor="let file of category.rightStudyFiles; trackBy: trackByStudyFile">
                        <app-xray-item [studyFile]="file"
                                       [mediaCategoryId]="file.mediaCategoryId"
                                       [mediaGroups]="mediaGroupsAll$ | async"
                                       [viewMode]="viewMode"
                                       [mediaCategories]="mediaCategories$ | async"
                                       [viewonly]="viewOnly"
                                       [isEditable]="isEditable"
                                       [isShowUpload]="false"
                                       (changeCategoryClicked)="emitChangeMediaCategory($event)"
                                       (viewImage)="viewImage($event)"></app-xray-item>
                      </ng-container>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>

          </ng-container>
        </div>
      </div>
    </div>
  </section>

</div>
